<template>
  <div>
    <div class="ShowCreateMelkUser">
      <el-scrollbar height="100%" ref="scrollbar">
        <!-- <div class="TopShowBackToPage">
          <h1>دفاتر فایل</h1>

          <div class="ShowToUserFileMe">
            <div class="ShowToUserFileMeV">
              <div class="topNav__searchbar_wrapper filterSearchBar">
                <div class="filterbutton_wrapper profileFilterBtn">
                  <button
                    ref="filterButton"
                    class="filterbutton"
                    @click="toggleFilter"
                  >
                    <VsxIcon
                      iconName="Setting4"
                      :size="24"
                      color="#000"
                      type="linear"
                    />
                  </button>
                </div>

                <div
                  :style="dynamicStyles"
                  class="filter profileFilter"
                  ref="filterBox"
                >
                  <div class="filter__container">
                    <el-input
                      style="width: 240px"
                      v-model="fillter.title"
                      placeholder="عنوان ملک"
                    />
                    <DatePicker
                      clearable
                      class="el-input__wrapper"
                      v-model="fillter.date"
                      input-format="jYYYY-jMM-jDD"
                      format="YYYY-MM-DD"
                      placeholder="تاریخ را وارد کنید"
                    />
                    <el-select
                      v-model="fillter.main_category"
                      placeholder="نوع فایل"
                      size="large"
                      style="
                        background: #f5f5f5;
                        min-width: 130px;
                        border-radius: 10px !important;
                        padding: 0 !important;
                      "
                    >
                      <el-option :label="'همه'" :value="'all'" />
                      <el-option
                        v-for="(v, i) in $store.state.c_set.main_category"
                        :key="i"
                        :label="v"
                        :value="i"
                      />
                    </el-select>

                    <el-select
                      v-model="fillter.order_by"
                      placeholder="مرتب سازی براساس"
                      size="large"
                      style="
                        background: #f5f5f5;
                        min-width: 130px;
                        border-radius: 10px !important;
                        padding: 0 !important;
                      "
                    >
                      <el-option
                        v-for="item in sorts"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>

                    <el-select
                      v-model="fillter.consultant"
                      placeholder="مشاور"
                      size="large"
                      style="
                        background: #f5f5f5;
                        min-width: 130px;
                        border-radius: 10px !important;
                        padding: 0 !important;
                      "
                    >
                      <el-option :label="'همه مشاوران'" :value="0" />
                      <el-option
                        v-for="(item, i) in consultant_list"
                        :key="i"
                        :label="item.nickname"
                        :value="item.id"
                      />
                    </el-select>

                    <div class="filterButton__wrapper">
                      <button
                        v-if="!isLoading"
                        @click="load_post('first'), toggleFilter()"
                        class="searchButton"
                      >
                        فیلتر
                      </button>
                      <button v-if="isLoading" class="searchButton">
                        فیلتر
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>
        </div> -->
        <div class="createMelkHeader phoneBookHeader">
          <!-- <div style="display: flex; align-items: center; gap: 10px"> -->
          <div class="createMelkHeaderContainer">
            <div class="createMelkHeaderTitle">
              <h1>پروژه‌های من</h1>
              <!-- <div
              v-if="editform"
              @click="clear_form()"
              class="ButtonCreateAdvisors"
            >
              جدید
            </div> -->
            </div>
            <div class="showFormBtn" @click="formTypeHandler('add')">
              <i class="fa-solid fa-plus"></i>
            </div>
            <div @click="closeBtn" class="ShowIconVsIcon">
              <i class="fas fa-arrow-left" style="font-size: 24px"></i>
            </div>
          </div>
        </div>

        <div class="showFileMain mainContainer">
          <div class="mainFilterBox" :class="{ show: showFilter }">
            <div class="fiterboxHeader">
              <div class="filterTitle">فیلتر</div>
              <div class="ShowIconVsIcon" @click="formCloseHandler('filter')">
                <i class="fas fa-arrow-left" style="font-size: 24px"></i>
              </div>
            </div>
            <div class="filterInputsWrapper">
              <div class="filterInputGroup">
                <input
                  class="filterGroupInput"
                  placeholder="عنوان پروژه"
                  v-model="fillter.title"
                  type="text"
                />
              </div>
              <!-- <div class="filterInputGroup">
                <DatePicker
                  clearable
                  v-model="fillter.date"
                  input-format="jYYYY-jMM-jDD"
                  format="YYYY-MM-DD"
                  placeholder="تاریخ را وارد کنید"
                />
              </div> -->
              <div class="filterInputGroup">
                <el-select
                  v-model="fillter.status"
                  placeholder="وضعیت پروژه"
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option :label="'همه'" :value="''" />
                  <el-option value="done" label="تحویل شده"> </el-option>
                  <el-option value="building" label="درحال ساخت"> </el-option>
                  <el-option value="pre_sale" label="پیش فروش"> </el-option>
                </el-select>
              </div>
              <div class="filterInputGroup">
                <el-select
                  v-model="fillter.order_by"
                  placeholder="مرتب سازی براساس"
                  size="large"
                  style="
                    background: #f5f5f5;
                    min-width: 130px;
                    border-radius: 10px !important;
                    padding: 0 !important;
                  "
                >
                  <el-option
                    v-for="item in sorts"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>
            <div class="filterBtnsWrapper">
              <div class="filterBTn" @click="load_post('first', true)">
                <div class="filterBtnTitle">
                  <span class="filterBtnTitleRes">نمایش</span> فیلتر
                </div>
                <div class="filterBtnIcon">
                  <VsxIcon
                    iconName="Setting4"
                    :size="14"
                    color="#fff"
                    type="linear"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="resFilterWrapper" @click="filterOpenHandler"> -->
          <!-- <div class="filesSwitchWrapper" :class="fillter.status">
            <div class="switchToggler"></div>
            <div
              class="switchThumb approved"
              @click="filterStatusHandler('approved')"
            >
              فعال
            </div>
            <div
              class="switchThumb archived"
              @click="filterStatusHandler('archived')"
            >
              غیر فعال
            </div>
          </div> -->
          <div class="resFilterWrapper">
            <div class="filterSearchWrapper">
              <input
                type="search"
                inputmode="search"
                enterkeyhint="search"
                class="searchInput"
                v-model="fillter.title"
                placeholder="جستجوی پروژه"
                @keyup.enter="load_post('first')"
              />
              <div class="searchIcon">
                <i class="fas fa-search"></i>
              </div>
            </div>
            <div class="filterToggle" @click="formTypeHandler('filter')">
              <VsxIcon
                iconName="Setting4"
                :size="20"
                color="#000"
                type="linear"
              />
            </div>
          </div>
          <!-- <div class="filterShortCut">
            <div class="filterThumb">
              <el-select placeholder="نوع فایل"
                  v-model="fillter.main_category"
                  @select="load_post('first', true)">
                <el-option :label="'همه'" :value="'all'" />
                  <el-option
                    v-for="(v, i) in $store.state.c_set.main_category"
                    :key="i"
                    :label="v"
                    :value="i"
                  />
              </el-select>
            </div>
            <div class="filterThumb">
              <el-select placeholder="دسته بندی">
                <el-option value="all" label="همه" />
              </el-select>
            </div>
            <div class="filterThumb">
              <el-select placeholder="نوع آگهی">
                <el-option value="Ads" label="آگهی شده" />
                <el-option value="noAds" label="آگهی نشده" />
              </el-select>
            </div>
          </div> -->
          <div class="filesList" v-show="post_list.length > 0 && !isLoading">
            <div
            class="listThumb"
            v-for="(v, i) in post_list"
            :key="i"
            @click="profileDetailsOpenHandler(v, i)"
          >
            <div class="thumbPic">
              <img :src="v.avatar" alt="" />
            </div>
            <div class="thumbContent">
              <div class="contentTitleWrapper">
                <div class="contentTitle">
                  {{ v.content }}
                </div>
                <div class="contentStatus">
                  {{ v.status_fa }}
                </div>
              </div>
              <div class="contentDesc">
                {{ v.details }}
              </div>
              <div class="contentDetails">
                <div class="detailsRate">
                  <div class="rateThumb">
                    <i class="fas fa-heart"></i>
                    <span>{{ v.likes }}</span>
                  </div>
                  <div class="rateThumb">
                    <i class="fas fa-comment"></i>
                    <span>{{ v.comments_count }}</span>
                  </div>
                </div>
                <div class="detailsDate">
                  <div class="dateThumb">
                    {{ v.created_fa }}
                  </div>
                </div>
              </div>
              <div class="contentOptions">
                <div class="optionBtn editBtn"
                  @click.stop="editFileOpenHandler(v.id)"
                >
                  <span>ویرایش</span>
                  <i class="fas fa-edit"></i>
                </div>
                <div class="optionBtn delBtn"
                  v-if="!delLoading"
                  @click.stop="del_post(v.id)"
                >
                  <span>حذف</span>
                  <i class="fas fa-trash"></i>
                </div>
                <div class="optionBtn delBtn"
                  v-if="delLoading"
                >
                  <div class="delLoader"></div>
                </div>
              </div>
            </div>
          </div>
            <!-- <div
              class="fileThumb"
              v-for="(typeMelks, index) in post_list"
              :key="index"
            >
              <div class="thumbPic">
                <img :src="typeMelks.avatar" alt="" />
              </div>
              <div class="thumbContent">
                <div class="contentHeader">
                  <div class="propertyTitle">{{ typeMelks.content }}</div>
                  <div class="pripertyCategoryWrapper">
                    <div class="categoryThumb">
                      {{ typeMelks.main_category }}
                    </div>
                  </div>
                </div>
                <div class="contentMain">
                  <div class="propertyOptionWrapper">
                    <div class="propertyOptionTitle">
                      <div class="titleIcon">
                        <i class="fas fa-ruler-combined"></i>
                      </div>
                      <div class="titleValue">متراژ:</div>
                    </div>
                    <div class="peropertyOptionValue">
                      {{ typeMelks.building_area }}
                    </div>
                  </div>
                  <div
                    class="propertyOptionWrapper"
                    v-if="typeMelks.main_category_en == 'trade'"
                  >
                    <div class="propertyOptionTitle">
                      <div class="titleIcon">
                        <i class="fas fa-tag"></i>
                      </div>
                      <div class="titleValue">خرید:</div>
                    </div>
                    <div class="peropertyOptionValue">
                      {{ typeMelks.total_price }}
                    </div>
                  </div>
                  <div
                    class="propertyOptionWrapper"
                    v-if="typeMelks.main_category_en == 'rent'"
                  >
                    <div class="propertyOptionTitle">
                      <div class="titleIcon">
                        <i class="fas fa-tag"></i>
                      </div>
                      <div class="titleValue">اجاره:</div>
                    </div>
                    <div class="peropertyOptionValue">
                      {{ typeMelks.rent_price }}
                    </div>
                  </div>
                  <div
                    class="propertyOptionWrapper"
                    v-if="typeMelks.main_category_en == 'rent'"
                  >
                    <div class="propertyOptionTitle">
                      <div class="titleIcon">
                        <i class="fas fa-tag"></i>
                      </div>
                      <div class="titleValue">رهن:</div>
                    </div>
                    <div class="peropertyOptionValue">
                      {{ typeMelks.mortgage_price }}
                    </div>
                  </div>
                  <div class="propertyOptionWrapper">
                    <div class="propertyOptionTitle">
                      <div class="titleIcon">
                        <i class="fas fa-calendar"></i>
                      </div>
                      <div class="titleValue">تاریخ ثبت:</div>
                    </div>
                    <div class="peropertyOptionValue">
                      {{ typeMelks.created_at }}
                    </div>
                  </div>
                </div>
                <div class="contentFooter">
                  <div class="propertyBtnsWrapper">
                    <div
                      class="propertyBtn detailsBtn"
                      @click="showPost(index)"
                    >
                      <div class="propertyBTnICON">
                        <i class="fas fa-info-circle"></i>
                      </div>
                      <div class="propertybTnTitle">جزئیات</div>
                    </div>
                    <div
                      class="propertyBtn editBtn pointer"
                      @click="formTypeHandler('edit', typeMelks.id)"
                    >
                      <div class="propertyBTnICON">
                        <i class="fas fa-edit"></i>
                      </div>
                      <div class="propertybTnTitle">ویرایش</div>
                    </div>
                    <div
                      class="propertyBtn deleteBtn pointer"
                      @click="del_post(typeMelks.id)"
                    >
                      <div class="propertyBTnICON">
                        <i class="fas fa-trash"></i>
                      </div>
                      <div class="propertybTnTitle">حذف</div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
          <div class="loadeMoreLoader" v-if="loadmore_loading">
            <span class="custom-loader"></span>
          </div>
          <div
            ref="loadMoreTrigger"
            class="trigger"
            v-show="post_list.length > 0 && !isLoading"
          ></div>
          <div
            v-if="post_list.length == 0 && !isLoading"
            class="justify-center align-center mt-4"
            style="text-align: center; height: 90%"
          >
            <img
              src="/img/notfound.png"
              alt="Alt text"
              width="320"
              height="280"
            />
            <h2 class="nothing" style="font-size: 14px">پروژه‌ای یافت نشد</h2>
          </div>
        </div>

        <!-- <div :style="divTop" class="SearchBoxToUser">
          <input placeholder="عنوان ملک" v-model="fillter.title" type="text" />
          <DatePicker
            clearable
            v-model="fillter.date"
            input-format="jYYYY-jMM-jDD"
            format="YYYY-MM-DD"
            placeholder="تاریخ را وارد کنید"
          />
          <el-select
            v-model="fillter.main_category"
            placeholder="نوع فایل"
            size="large"
            style="
              background: #f5f5f5;
              min-width: 130px;
              border-radius: 10px !important;
              padding: 0 !important;
            "
          >
            <el-option :label="'همه'" :value="'all'" />
            <el-option
              v-for="(v, i) in $store.state.c_set.main_category"
              :key="i"
              :label="v"
              :value="i"
            />
          </el-select>

          <el-select
            v-model="fillter.order_by"
            placeholder="مرتب سازی براساس"
            size="large"
            style="
              background: #f5f5f5;
              min-width: 130px;
              border-radius: 10px !important;
              padding: 0 !important;
            "
          >
            <el-option
              v-for="item in sorts"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>

          <el-select
            v-model="fillter.consultant"
            placeholder="مشاور"
            size="large"
            style="
              background: #f5f5f5;
              min-width: 130px;
              border-radius: 10px !important;
              padding: 0 !important;
            "
          >
            <el-option :label="'همه مشاوران'" :value="0" />
            <el-option
              v-for="(item, i) in consultant_list"
              :key="i"
              :label="item.nickname"
              :value="item.id"
            />
          </el-select>
          <button
            v-if="!isLoading"
            @click="load_post('first')"
            class="ShowFilterFile"
          >
            فیلتر
          </button>
          <button v-if="isLoading" class="ShowFilterFile">فیلتر</button>
        </div> -->

        <!-- <div class="ShowLineToUserMelk">
          <p>فایل های شما</p>
        </div>

        <div
          style="margin-top: 30px"
          v-if="post_list.length == 0 && isLoading"
          class="ShowFileToUserScrollBar"
        >
          <Skeletor
            v-for="(v, i) in 12"
            :key="i"
            class="ChildShowFileToUserScrollBar"
            height="400"
            style="
              background: rgb(163, 219, 213);
              margin-bottom: 2rem;
              border-radius: 10px;
            "
          />
        </div> -->

        <!-- <div v-show="post_list.length > 0 && !isLoading">
          <div class="ShowFileToUserScrollBar">
            <div
              v-for="(typeMelks, index) in post_list"
              :key="index"
              class="ChildShowFileToUserScrollBar"
            >
              <div class="TopShowToUserCdn">
                <div class="mobileFileTitle">
                  {{ typeMelks.content }}
                </div>
                <img :src="typeMelks.avatar" alt="" />
              </div>

              <div class="ShowToUSerCustomer">
                <div class="ALlTitleShowToUSerCustomer desktopFileTitle">
                  <div class="TitleShowToUSerCustomer">عنوان فایل</div>
                  <p>{{ typeMelks.content }}</p>
                </div>
                <div class="ALlTitleShowToUSerCustomer">
                  <div class="TitleShowToUSerCustomer">نوع فایل</div>
                  <p>{{ typeMelks.main_category }}</p>
                </div>

                <div
                  v-if="typeMelks.main_category_en == 'trade'"
                  class="ALlTitleShowToUSerCustomer"
                >
                  <div class="TitleShowToUSerCustomer">قیمت متری</div>
                  <p>{{ typeMelks.meter_price }}</p>
                </div>
                <div
                  v-if="typeMelks.main_category_en == 'trade'"
                  class="ALlTitleShowToUSerCustomer"
                >
                  <div class="TitleShowToUSerCustomer">قیمت کل</div>
                  <p>{{ typeMelks.total_price }}</p>
                </div>

                <div
                  v-if="typeMelks.main_category_en == 'rent'"
                  class="ALlTitleShowToUSerCustomer"
                >
                  <div class="TitleShowToUSerCustomer">قیمت رهن</div>
                  <p>{{ typeMelks.mortgage_price }}</p>
                </div>
                <div
                  v-if="typeMelks.main_category_en == 'rent'"
                  class="ALlTitleShowToUSerCustomer"
                >
                  <div class="TitleShowToUSerCustomer">قیمت اجاره</div>
                  <p>{{ typeMelks.rent_price }}</p>
                </div>

                <div class="ALlTitleShowToUSerCustomer">
                  <div class="TitleShowToUSerCustomer">تاریخ ثبت</div>
                  <p>{{ typeMelks.created_at }}</p>
                </div>
                <div class="d-flex showFileBtns" style="gap: 5px">
                  <div @click="showPost(index)" class="ButtonShowOtherModel">
                    <VsxIcon
                      iconName="More"
                      :size="20"
                      color="#f5f5f5  "
                      type="linear"
                    />
                    جزئیات بیشتر
                  </div>
                  <div
                    @click="editPost(typeMelks.id)"
                    class="ButtonShowOtherModel"
                  >
                    <i class="fa-solid fa-pen"></i>
                    ویرایش
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="loadeMoreLoader" v-if="loadmore_loading">
            <span class="custom-loader"></span>
          </div>
          <div ref="loadMoreTrigger" class="trigger"></div>
        </div> -->

        <!-- <div
          v-if="post_list.length > 0 && loadmore && !isLoading"
          class="loadButtonarea"
        >
          <button
            class="loadButton"
            @click="load_post()"
            :disabled="loadmore_loading"
          >
            <span v-if="!loadmore_loading">نمایش بیشتر</span>
            <span v-else class="loader"></span>
          </button>
        </div> -->

        <!-- <div
          v-if="post_list.length == 0 && !isLoading"
          class="justify-center align-center mt-4"
          style="text-align: center; height: 90%"
        >
          <img
            :src="publicPath + 'img/notfound.png'"
            alt="Alt text"
            width="320"
            height="280"
          />
          <h2 style="font-size: 14px">فایلی یافت نشد</h2>
        </div> -->
      </el-scrollbar>
    </div>

    <div
      @click="ShowModel = false"
      v-if="ShowModel"
      role="dialog"
      aria-labelledby="امکانات اقامتگاه"
      class="j-modal"
      style="--padding-left: 0px; --padding-right: -17px"
    >
      <div @click.stop class="product-modal">
        <header class="product-modal-header">
          <p class="product-modal-header__title">امکانات ملک</p>

          <div
            @click="ShowModel = false"
            role="button"
            class="product-modal-header__close"
          ></div>
        </header>
        <div class="product-modal-content">
          <div class="product-modal-content__container">
            <el-scrollbar style="padding: 0 30px" height="600px">
              <div class="product-amenities-modal__content">
                <div class="product-amenities-modal-section">
                  <div class="product-amenities-modal-section__title">
                    امکانات رفاهی
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">آنتن‌دهی موبایل</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>رایتل 4G/LTE<i></i></span>
                      <span>همراه اول 4G/LTE<i></i></span>
                      <span>ایرانسل 4G/LTE<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">سیستم سرمایشی</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>کولر آبی<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">سیستم گرمایشی</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>بخاری گازی<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">مبلمان</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">تلویزیون</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">آب</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">برق</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">گاز</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text"
                        >گیرنده دیجیتال ایران</span
                      >
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text">جالباسی</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                </div>
                <div class="product-amenities-modal-section">
                  <div class="product-amenities-modal-section__title">
                    امکانات بهداشتی
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <span class="product-amenity__text"
                        >سرویس بهداشتی ایرانی</span
                      >
                    </div>
                    <div class="product-amenity__detail">
                      <span>اشتراکی<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/70af058b-97f1-4cc8-9fed-27041944ab31.svg"
                          alt="تصویر سرویس بهداشتی فرنگی"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text"
                        >سرویس بهداشتی فرنگی</span
                      >
                    </div>
                    <div class="product-amenity__detail">
                      <span>اشتراکی<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/241e315c-578b-463b-bd1f-ef1aa9ac801a.svg"
                          alt="تصویر حمام"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">حمام</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>اشتراکی<i></i></span>
                    </div>
                  </div>
                </div>
                <div class="product-amenities-modal-section">
                  <div class="product-amenities-modal-section__title">
                    امکانات آشپزخانه
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/f94cfe17-0169-4894-a06f-d993cf3ea244.svg"
                          alt="تصویر لوازم سرو غذا"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">لوازم سرو غذا</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>بشقاب<i></i></span>
                      <span>قاشق<i></i></span>
                      <span>چنگال<i></i></span>
                      <span>لیوان<i></i></span>
                      <span>کتری<i></i></span>
                      <span>قوری<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/58c2a5e9-eb55-403f-badc-195b04300a4e.svg"
                          alt="تصویر اجاق گاز"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">اجاق گاز</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/e9851a1b-a2e2-4751-a5c1-025918074d16.svg"
                          alt="تصویر یخچال"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">یخچال</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/c1d14ade-a7ba-4f3e-9826-2e85676bf29d.svg"
                          alt="تصویر آشپزخانه"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">آشپزخانه</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>اشتراکی<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/469faf28-a5b4-4ab9-8082-13dd60e1ad8d.svg"
                          alt="تصویر وسایل پخت و پز"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">وسایل پخت و پز</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>قابلمه<i></i></span>
                      <span>ماهیتابه<i></i></span>
                      <span>نمک<i></i></span>
                      <span>فلفل<i></i></span>
                    </div>
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/032f8c2b-214d-47ec-bb6a-52dfc6f27c2d.svg"
                          alt="تصویر کابینت"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">کابینت</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                </div>
                <div class="product-amenities-modal-section">
                  <div class="product-amenities-modal-section__title">
                    ایمنی
                  </div>
                  <div class="product-amenity">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/2736c620-a0b8-4a14-bbe4-94d5f46fb9d9.png"
                          alt="تصویر نگهبان"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">نگهبان</span>
                    </div>
                    <div class="product-amenity__detail">
                      <span>مستقر داخل اقامتگاه<i></i></span>
                    </div>
                  </div>
                </div>
                <div class="product-amenities-modal-section">
                  <div class="product-amenities-modal-section__title">
                    امکاناتی که در اقامتگاه فراهم نیست
                  </div>
                  <div class="product-amenity missed">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/d4e3b859-0a41-4e28-92d2-42ab42605af6.svg"
                          alt="تصویر پارکینگ"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">پارکینگ</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                  <div class="product-amenity missed">
                    <div class="product-amenity__main">
                      <figure class="product-amenity-icon">
                        <img
                          src="https://cdn.jabama.com/original/jabama-images/0/00f98674-75a4-47ca-9f3d-e33a32d42c39.png"
                          alt="تصویر استخر"
                          loading="lazy"
                          decoding="async"
                          class="product-amenity-icon__image"
                        />
                      </figure>
                      <span class="product-amenity__text">استخر</span>
                    </div>
                    <div class="product-amenity__detail"></div>
                  </div>
                </div>
              </div>
              <div class="product-amenities-modal-hint">
                <span class="product-amenities-modal-hint__title">توجه:</span>
                برای اطلاعات از جزییات بیشتر در مورد امکانات اقامتگاه به بخش
                <span class="product-amenities-modal-hint__link"
                  >توضیحات بیشتر</span
                >
                مراجعه کنید.
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div class="j-modal__overly"></div>
    </div>
<el-dialog
      v-model="showDetails"
      align-center
      modal-class="profileDetails"
      :show-close="false"
      @close="profileDetailsCloseHandler"
    >
      <div class="changePostBtn PrevBtn" @click.stop="postIndexDecrease">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m8.25 4.5 7.5 7.5-7.5 7.5"
          />
        </svg>
      </div>
      <div class="changePostBtn NextBtn" @click.stop="postIndexIncrease">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>
      </div>
      <div class="detailsContainer">
        <div class="containerList">
          <div class="listThumb">
            <div class="thumbPic">
              <!-- <img :src="post_list?.[postIndex]?.avatar" alt="" /> -->
              <Swiper
                ref="postSwiper"
                :slides-per-view="1"
                :space-between="16"
                :modules="module"
                :pagination="{
                  dynamicBullets: true,
                }"
                :navigation="true"
                @swiper="onSwiperInitialized"
              >
                <SwiperSlide>
                  <img :src="post_list?.[postIndex]?.avatar" alt="" />
                </SwiperSlide>
                <SwiperSlide
                  v-for="(v, i) in post_list[postIndex]?.photo_galleries_mobile"
                  :key="i"
                >
                  <img :src="v.url" alt="" /> </SwiperSlide
                >
                <SwiperSlide  v-show="post_list && post_list[postIndex] && post_list[postIndex].lat && post_list[postIndex].lng">
                  <div id="map" class="map"></div>
                </SwiperSlide>
            </Swiper>
            </div>
            <div class="thumbContent">
              <div class="contentHeader">
                <div class="headerContent">
                  <div class="contentPic">
                    <img :src="$store.state.auth?.avatar" alt="" />
                  </div>
                  <div class="contentInfo">{{ $store.state.auth?.nickname }}</div>
                </div>
                <div class="headerOptions">
                  <div
                    v-if="
                      $store.state.auth.loggedIn &&
                      $store.state.auth.uid == $store.state.auth.uid
                    "
                    @click="editFileOpenHandler(post_list?.[postIndex]?.id)"
                    class="optionEditBtn"
                  >
                    <i class="fas fa-edit"></i>
                  </div>
                  <div
                    v-if="
                      $store.state.auth.loggedIn &&
                      $store.state.auth.uid == $store.state.auth.uid
                    "
                    @click="del_post(post_list?.[postIndex]?.id)"
                    class="optionDelete"
                  >
                    <i class="fas fa-trash"></i>
                  </div>
                </div>
              </div>
              <div ref="contentMain" class="contentMain">
                <div class="mianHeader">
                  <div class="headerStatus">
                    {{ post_list?.[postIndex]?.status_fn }}
                  </div>
                  <div class="headerTitle">
                    {{ post_list?.[postIndex]?.content }}
                  </div>
                  <div
                    class="headerContent"
                    v-html="formattedDetails(post_list?.[postIndex]?.details)"
                  ></div>
                </div>
                <div class="mainOptions">
                  <div class="optionsList">
                    <div
                      @click="save_like(post_list?.[postIndex]?.id)"
                      class="optionThumb"
                      :class="{ liked: post_list?.[postIndex]?.is_like == 2 }"
                    >
                      <svg
                        v-if="post_list?.[postIndex]?.is_like == 1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                        />
                      </svg>
                      <svg
                        v-if="post_list?.[postIndex]?.is_like == 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"
                        />
                      </svg>

                      <div class="thumbNum">
                        {{ post_list?.[postIndex]?.likes }}
                      </div>
                    </div>
                    <div class="optionThumb">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 0 1-.923 1.785A5.969 5.969 0 0 0 6 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337Z"
                        />
                      </svg>
                      <div class="thumbNum">
                        {{ post_list?.[postIndex]?.comments_count }}
                      </div>
                    </div>
                    <div
                      @click="shareContent(post_list?.[postIndex]?.id)"
                      class="optionThumb"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                        />
                      </svg>
                    </div>
                  </div>
                  <!-- <div
                    class="optionsList"
                    @click="save_favorit(post_list[postIndex]?.id)"
                  >
                    <div class="optionThumb">
                      <svg
                        v-if="post_list[postIndex]?.is_favorite == 1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
                        />
                      </svg>
                      <svg
                        v-if="post_list[postIndex]?.is_favorite == 2"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        class="size-6"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6.32 2.577a49.255 49.255 0 0 1 11.36 0c1.497.174 2.57 1.46 2.57 2.93V21a.75.75 0 0 1-1.085.67L12 18.089l-7.165 3.583A.75.75 0 0 1 3.75 21V5.507c0-1.47 1.073-2.756 2.57-2.93Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div> -->
                </div>
                <div
                  v-if="
                    postCommentsList.length > 0 && !commentsLoademoreLoading
                  "
                  class="mainList"
                >
                  <div
                    v-for="(CommentUserLists, i) in postCommentsList"
                    :key="i"
                    class="listThumb"
                  >
                    <div class="listThumbWrapper">
                      <div class="thumbPic">
                        <img
                          :src="CommentUserLists.avatar"
                          :alt="CommentUserLists.name"
                        />
                      </div>
                      <div class="thumbContent">
                        <div class="contentDesc">
                          <span class="userTitle">{{
                            CommentUserLists.name
                          }}</span>
                          {{ CommentUserLists.description }}
                        </div>
                        <div class="contentDetails">
                          <div class="detailsTime">
                            {{ CommentUserLists.date }}
                          </div>
                          <div
                            class="detailsReply"
                            @click="post_replay_focuse(CommentUserLists.id)"
                          >
                            پاسخ دادن
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="thumbReplyList">
                      <div
                        v-for="(replaies, j) in CommentUserLists.replay"
                        :key="j"
                        class="listThumb"
                      >
                        <div class="listThumbWrapper">
                          <div class="thumbPic">
                            <img :src="replaies.avatar" :alt="replaies.name" />
                          </div>
                          <div class="thumbContent">
                            <div class="contentDesc">
                              <span class="userTitle">{{ replaies.name }}</span>
                              {{ replaies.description }}
                            </div>
                            <div class="contentDetails">
                              <div class="detailsTime">
                                {{ replaies.date }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mobileNocomments"
                  v-if="
                    postCommentsList.length == 0 && !commentsLoademoreLoading
                  "
                >
                  نظری ثبت نشده است
                </div>
                <div class="loadeMoreLoader" v-if="commentsLoademoreLoading">
                  <span class="custom-loader"></span>
                </div>
              </div>
              <div class="contentFooter">
                <div class="footerFooter">
                  <div v-if="$store.getters.auth.loggedIn" class="footerGroup">
                    <div
                      v-if="!post_comment_btn_loading"
                      @click="postCommentsSaveHandler(0, 'mob')"
                      class="groupButton"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 640 640"
                      >
                        <path
                          d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
                        />
                      </svg>
                    </div>
                    <div v-if="post_comment_btn_loading" class="groupButton">
                      <span class="postCommentloader"></span>
                    </div>
                    <input
                      type="text"
                      class="groupInput"
                      id="postComment"
                      :class="{ reply: postParent_id != 0 }"
                      placeholder="کامنت خود را بنویسید"
                      v-model="postNewComment"
                    />
                    <div
                      v-if="postParent_id !== 0"
                      class="cancleReply"
                      @click="replay_blur"
                    >
                      انصراف
                    </div>
                  </div>
                  <div
                    v-if="!$store.getters.auth.loggedIn"
                    class="loginAlerContainer"
                  >
                    <div class="loginAler">
                      برای ثبت نظر وارد حساب کاربری شوید
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <EditMelk
      v-if="EditModel"
      :postId="postId"
      @close="formCloseHandler('edit')"
    ></EditMelk>
    <createMelk v-if="addFile" @close="formCloseHandler('add')" />
  </div>
</template>

<script>
// import DatePicker from "@alireza-ab/vue3-persian-datepicker";
import "@majidh1/jalalidatepicker/dist/jalalidatepicker.min.css";
import "@majidh1/jalalidatepicker";
// import { Skeletor } from "vue-skeletor";
import store from "@/store";
import EditMelk from "@/components/profile/editMelk";
import { nextTick } from "vue";
import createMelk from "./createMelk.vue";
import { toast } from "vue3-toastify";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css";

export default {
  name: "ShowFile",
  components: {
    EditMelk,
    // DatePicker,
    createMelk,
    Swiper,
    SwiperSlide,
  },
  props: {
    BranchInfos: Object,
  },
  data() {
    return {
      // publicPath: process.env.VUE_APP_PUBLIC_PATH,
      module: [Navigation, Pagination],
      ShowModel: false,
      addFile: false,
      color: "",
      value: "",
      showFile: false,
      showFilter: false,
      EditModel: false,
      isFilterOpen: false,
      filterBackAction: false,
      editBackAction: false,
      filterStatus: "active",
      sorts: [
        { value: "newest", label: "جدیدترین" },
        { value: "oldest", label: "قدیمی‌ترین" },
      ],
      divTop: "0",
      widthTop: "100%",
      dynamicStyles:
        "height: 0; overflow: hidden; transition: height 0.3s ease;",
      loadmore: false,
      loadmore_loading: false,
      editLoading: null,
      delLoading: false,
      fillter: {
        main_category: "all",
        category: "all",
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        bed: -1,
        page: 1,
        per_page: 12,
        date: "",
        role: "builder",
        consultant: 0,
        list_type: 'own_profile',
        post_type:'portfolio',
        status:'',
      },

      isLoading: false,
      post_list: [],
      consultant_list: [],
      postId: 0,
      formType: "",
      showDetails: false,
      postIndex: null,
      Commentpage: 1,
      commentsTotal: 0,
      postCommentsList: [],
      commentsLoadeMore: true,
      commentsLoading: false,
      commentsLoademoreLoading: false,
      postComment_btn_replay_loading: [],
      postParent_id: 0,
      postNewComment: "",
      post_comment_replay: [],
      post_comment_btn_loading: false,
      postreplyComment: -1,
      completeInfos: [],
      postSwiper: null,
      map: null,
      reloadKey: 0,
      markersLayer: null,
      markerOne: null,
      loadMoreTrigger: null,
      center: { latitude: 36.5663854, longitude: 52.6707147 },
      markerPosition: { longitude: 0, latitude: 0 },
      houseIcon: L.divIcon({
        html: `
          <div style="position: relative;">
            <div style="
              position: absolute;
              width: 70px;
              height: 70px;
              background: rgba(0, 0, 0, 0.2);
              border-radius: 50%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            "></div>
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="67" height="67" viewBox="0 0 67 67">
                <defs>
                    <filter id="cxwfhygxxa" width="211.1%" height="211.1%" x="-55.6%" y="-55.6%" filterUnits="objectBoundingBox">
                        <feOffset in="SourceAlpha" result="shadowOffsetOuter1"/>
                        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/>
                        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.461511145 0"/>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                    <path id="m1l7efvoab" d="M15.317 5.098L8.435.183c-.341-.244-.8-.244-1.142 0L.412 5.098c-.442.316-.544.93-.229 1.371.315.443.93.544 1.371.23l.412-.295v8.341c0 .543.44.983.983.983h9.83c.544 0 .983-.44.983-.983v-8.34c.343.244.587.476.982.476.308 0 .61-.143.801-.412.316-.441.213-1.055-.228-1.371zm-3.52 8.664H9.83v-2.949c0-1.086-.88-1.966-1.966-1.966-1.086 0-1.966.88-1.966 1.966v2.95H3.932V5L7.864 2.19 11.796 5v8.762z"/>
                </defs>
                <g fill="none" fill-rule="evenodd" filter="url(#cxwfhygxxa)" transform="translate(15.127 15.127)">
                    <rect width="32.887" height="32.887" x="1.43" y="1.43" fill="#213743" stroke="#192B37" stroke-width="2.86" rx="8.579"/>
                    <g transform="translate(10.009 10.009)">
                        <mask id="wd87vlifuc" fill="#fff">
                            <use xlink:href="#m1l7efvoab"/>
                        </mask>
                        <use fill="#000" fill-rule="nonzero" xlink:href="#m1l7efvoab"/>
                        <g fill="#FFF" mask="url(#wd87vlifuc)">
                            <path d="M0 0H15.728V15.728H0z"/>
                        </g>
                    </g>
                </g>
            </svg>
          </div>`,
        className: "house-marker",
        iconSize: [70, 70],
        iconAnchor: [35, 35],
      }),
    };
  },
  watch: {
    showFile(newValue) {
      document.body.style.overflow = newValue ? "hidden" : "auto";
    },
    showFilter(newValue) {
      this.$emit("filterStatus", newValue);
    },
    EditModel(newValue) {
      this.$emit("filterStatus", newValue);
    },
    formType(newValue) {
      this.$emit("filterStatus", newValue);
    },
  },
  async mounted() {
    const statuss = localStorage.getItem("status");
    if (statuss) {
      this.filterStatusHandler(statuss);
      localStorage.removeItem("status");
    } else {
      this.load_post("first");
    }
    window.addEventListener("popstate", this.handleBackBtn);
    setInterval(() => {
      this.loadTheme();
    }, 100);

    this.load_consultant();
    this.ShowToUser();
    window.jalaliDatepicker.startWatch({
      maxDate: "today",
    });
    await nextTick();
    this.loadMoreTrigger = this.$refs.loadMoreTrigger;
    this.$nextTick(() => {
      const wrap = this.$refs.scrollbar?.wrapRef;
      if (wrap) {
        wrap.addEventListener("scroll", this.handleScroll);
      }
    });
    // const observer = new IntersectionObserver(
    //   ([entry]) => {
    //     if (entry.isIntersecting) {
    //       this.load_post();
    //     }
    //   },
    //   { threshold: 1.0 }
    // );
    // if (this.loadMoreTrigger) {
    //   observer.observe(this.loadMoreTrigger);
    // }
  },
  beforeUnmount() {
    window.removeEventListener("popstate", this.handleBackBtn);
    const wrap = this.$refs.scrollbar?.wrapRef;
    if (wrap) {
      wrap.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    formattedDetails(content) {
      return content ? content.replace(/(\r\n|\n|\r)/g, "<br>") : '';
    },
    async initializeMap() {
      try {
        if (!this.map) {
          this.map = L.map("map", {
            dragging: true,
            touchZoom: true,
            scrollWheelZoom: true,
            doubleClickZoom: true,
            boxZoom: true,
            keyboard: true,
            zoomControl: true,
          });

          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 20,
            minZoom: 5,
            attribution: "© OpenStreetMap Abarline",
          }).addTo(this.map);
        }

        this.updateMapLocation();
      } catch (error) {
        console.error("Map initialization error:", error);
      }
    },
    updateMapLocation() {
      const lat = this.post_list?.[this.postIndex]?.lat;
      const lng = this.post_list?.[this.postIndex]?.lng;

      if (!lat || !lng) return;

      this.map.setView([lat, lng], 16);

      if (this.markerOne) {
        this.map.removeLayer(this.markerOne);
      }

      this.markerOne = L.marker([lat, lng], { icon: this.houseIcon }).addTo(
        this.map
      );

      this.map.invalidateSize();
    },

    getmounted(map) {
      this.map = map;
      this.initializeMap(map);
    },
    onSwiperInitialized(swiper) {
      this.postSwiper = swiper;
    },
    getPostHandler() {
      this.helperPost("public-post-list", this.form).then((response) => {
        if (response.data.result == "1") {
          this.postList = response.data.data.list;
        }
      });
    },
    profileDetailsOpenHandler(post, index) {
      if (window.innerWidth > 1000) {
        this.showDetails = true;
        if (this.postSwiper) {
          this.postSwiper.slideTo(0);
        }
        this.postIndex = index;
        this.postCommentLoadHandler("first");
        this.$nextTick(() => {
          this.setupScrollListener();
          if (this.map) {
            this.map.remove();
            this.map = null;
            this.markerOne = null;
          }

          this.$nextTick(() => {
            this.initializeMap();
          });
        });
      } else {
        this.$router.push(
          `/builder-details/${this.$store.state.auth.uid}/${post.id}`
        );
      }
    },
    profileDetailsCloseHandler() {
      this.showDetails = false;
    },
    postIndexIncrease() {
      if (this.postIndex < this.post_list.length - 1) {
        this.postIndex++;
        this.postCommentLoadHandler("first");
        console.log("this.postSwiper", this.postSwiper);
        if (this.postSwiper) {
          this.postSwiper.slideTo(0, 0);
        }
        this.$nextTick(() => {
          this.updateMapLocation();
        });
      }
    },
    postIndexDecrease() {
      if (this.postIndex > 0) {
        this.postIndex--;
        this.postCommentLoadHandler("first");
        if (this.postSwiper) {
          this.postSwiper.slideTo(0, 0);
        }
        this.$nextTick(() => {
          this.updateMapLocation();
        });
      }
    },
    setupScrollListener() {
      const scrollElement = this.$refs.contentMain;
      if (!scrollElement) return;

      scrollElement.addEventListener("scroll", this.handlePostCommentScroll);
    },
    handlePostCommentScroll() {
      const scrollElement = this.$refs.contentMain;
      if (!scrollElement) return;

      const scrollTop = scrollElement.scrollTop;
      const scrollHeight = scrollElement.scrollHeight;
      const clientHeight = scrollElement.clientHeight;
      // اگر 100 پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.commentsLoadeMore && !this.commentsLoademoreLoading) {
          this.postCommentLoadHandler(); // متد مورد نظر شما برای لود بیشتر
        }
      }
    },
    postCommentLoadHandler(param) {
      let self = this;
      this.commentsLoadeMore = true;
      this.commentsLoademoreLoading = true;
      this.page += 1;
      if (param == "first") {
        this.commentsLoading = true;
        this.postCommentsList = [];
        this.Commentpage = 1;
      }

      this.helperGet(
        "get-comment",
        "related_to=post" +
          "&related_id=" +
          this.post_list?.[this.postIndex]?.id +
          "&page=" +
          this.Commentpage
      ).then((res) => {
        if (res.data.result == 1) {
          this.total = res.data.data.total;
          // اضافه کردن کامنت‌های جدید به انتهای لیست
          const newComments = [...res.data.data.list].reverse(); // معکوس کردن ترتیب کامنت‌ها
          self.postCommentsList = self.postCommentsList.concat(newComments);

          if (res.data.data.total_page == self.Commentpage) {
            this.commentsLoadeMore = false;
          }
          self.postComment_btn_replay_loading = [];
          self.postCommentsList.forEach(function (v) {
            self.postComment_btn_replay_loading[v.id] = false;
          });
        }

        this.commentsLoading = false;
        this.commentsLoademoreLoading = false;
      });
    },
    postCommentsSaveHandler(parent_id = 0, from) {
      let self = this;
      const formData = new FormData();

      formData.append("related_id", this.post_list?.[this.postIndex]?.id);
      formData.append("related_to", "post");

      if (this.$store.state.auth.loggedIn)
        formData.append("author_id", this.$store.state.auth.uid);

      // تعیین parent_id برای ریپلای
      const actualParentId = from === "mob" ? this.postParent_id : parent_id;

      if (actualParentId !== 0) {
        formData.append("parent_id", actualParentId);
        formData.append(
          "newComment",
          from === "mob"
            ? this.postNewComment
            : this.post_comment_replay[actualParentId]
        );
        self.postComment_btn_replay_loading[actualParentId] = true;
      } else {
        formData.append("newComment", this.postNewComment);
        self.post_comment_btn_loading = true;
      }

      self.helperPost("save-comment", formData).then((r) => {
        if (r.data.result == "success") {
          // Create new comment object
          const newComment = {
            id: r.data.id || Date.now(),
            name: self.$store.state.auth.name || "کاربر",
            avatar: self.$store.state.auth.avatar || "",
            description:
              actualParentId !== 0
                ? from === "mob"
                  ? this.postNewComment
                  : this.post_comment_replay[actualParentId]
                : this.postNewComment,
            date: new Date().toLocaleDateString("fa-IR"),
            replay: [],
          };

          if (actualParentId !== 0) {
            // Add reply to parent comment
            const parentComment = self.postCommentsList.find(
              (comment) => comment.id === actualParentId
            );
            if (parentComment) {
              parentComment.replay.push(newComment);
            }
            if (from === "mob") {
              self.postNewComment = "";
            } else {
              self.post_comment_replay[actualParentId] = "";
            }
          } else {
            // Add new comment to end of list
            self.postCommentsList.push(newComment);
            self.postNewComment = "";
          }

          self.postreplyCommentCloseHandler();
          self.total += 1;

          toast("نظر شما با موفقیت ثبت شد", {
            type: "success",
            dangerouslyHTMLString: true,
          });
          self.postParent_id = 0;
        } else {
          toast(r.data.msg, {
            type: "error",
            dangerouslyHTMLString: true,
          });
        }
        self.postComment_btn_replay_loading[actualParentId] = false;
        self.post_comment_btn_loading = false;
      });
    },
    postreplyCommentCloseHandler() {
      this.postreplyComment = -1;
    },
    postreplyCommentHandler(index) {
      this.postreplyComment = index;
    },
    post_replay_focuse(parent_id = 0) {
      this.postParent_id = parent_id;
      if (document.getElementById("postComment")) {
        document.getElementById("postComment").focus();
      }
      if (document.getElementById("newComment_mob")) {
        document.getElementById("newComment_mob").focus();
      }
    },
    filterStatusHandler(status) {
      this.fillter.status = status;
      setTimeout(() => {
        this.load_post("first");
      }, 200);
    },
    clearForm() {
      this.fillter = {
        main_category: "all",
        category: "all",
        advertiser: "all",
        district: "0",
        order_by: "newest",
        view_mode: "list",
        user_id: 0,
        city: 0,
        m_id: 0,
        bed: -1,
        page: 1,
        per_page: 12,
        date: "",
        role: "builder",
        consultant: 0,
        list_type: 'own_profile',
        post_type:'portfolio',
        status:'',
      };
    },
    // handleBackBtn() {
    //   if (this.showFilter) {
    //     this.showFilter = false;
    //     this.clearForm();
    //     return;
    //   } else if (this.EditModel) {
    //     this.EditModel = false;
    //     this.load_post("first");
    //   }
    // },
    // filterOpenHandler() {
    //   this.showFilter = true;
    //   history.pushState(null, "", location.href);
    // },
    // filterCloseHandler() {
    //   // if (!this.filterBackAction) {
    //   // }
    //   history.back();
    //   setTimeout(() => {
    //     this.showFilter = false;
    //   }, 500);
    //   this.clearForm();
    // },
    load_post(param, close = false) {
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.post_list = [];
        this.fillter.page = 1;
      }

      if (this.$store.state.auth.role == 'customer' || this.$store.state.auth.role == 'builder') {
        this.fillter.user_id = this.$store.state.auth.uid;
      } else {
        this.fillter.user_id = this.BranchInfos.id;
      }
      this.helperPost("post-list", this.fillter).then((r) => {
        if (r.data.result == 0) {
          // this.post_list = [];
          if (param != "first") {
            this.fillter.page -= 1;
          }
        } else {
          this.post_list = this.post_list.concat(r.data.data.list);
          console.log("fileList", r.data.data);
          if (r.data.data.total_page == this.fillter.page) {
            this.loadmore = false;
          }
        }
        this.isLoading = false;
        this.loadmore_loading = false;
      });
      let windowWidth = window.innerWidth;
      if (windowWidth < 1000 && close) {
        this.formCloseHandler("filter");
      }
    },
    load_consultant() {
      this.helperPost("branch-users-list", { role: "consultant" }).then((r) => {
        this.consultant_list = r.data.list;
      });
    },
    handleScroll() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      // لیزی لود: اگر ۱۰۰ پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_post(); // متد لود داده‌هات
        }
      }

      // تغییر وضعیت یک div (مثلاً موقعیت فیلتر بالای صفحه)
      if (scrollTop > 100) {
        this.divTop = "top:20px; width:85%;margin: 0;right: 5%";
      } else {
        this.divTop = "top:80px; width:90%;margin: auto";
      }
    },

    ShowToUser() {
      this.showFile = true;
    },

    closeBtn() {
      history.back()
      this.showFile = false;
      document.body.style = "overflow: auto;";
    },

    loadTheme() {
      const width = window.innerWidth;
      this.color = width >= 1250 ? "#2dc653" : "#f5f5f5";
    },
    editFileOpenHandler(id) {
      if (id) {
        this.$router.push(`/builder-create-post/${id}`);
      }
    },

    toggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;

      this.dynamicStyles = this.isFilterOpen
        ? "height: 416px; overflow: hidden; transition: height 0.3s ease;"
        : "height: 0; overflow: hidden; transition: height 0.3s ease;";

      if (this.isFilterOpen) {
        setTimeout(() => {
          this.dynamicStyles =
            "height: 416px; overflow: inherit; transition: height 0.3s ease;";
        }, 300);
      }
    },
    showPost(post, index) {
      localStorage.removeItem("post_detail");
      store.commit("post_detail_set", this.post_list[index]);
      this.$router.push(`/details/${post.id}`);
      localStorage.setItem("openShowFile", true);
      localStorage.setItem("tComp", "ShowFile");
      localStorage.setItem("status", this.fillter.status);
      console.log("branchinfo");
    },
    // editPost(id) {
    //   this.postId = id;
    //   this.EditModel = true;
    //   history.pushState(null, "", location.href);
    // },
    // close_edit() {
    //   if (!this.editBackAction) {
    //     history.back();
    //   }
    //   setTimeout(() => {
    //     this.EditModel = false;
    //   }, 500);
    //   this.load_post("first");
    // },
    formTypeHandler(type, editId = null) {
      this.formType = type;

      // let windowWidth = window.innerWidth;
      // if (windowWidth < 1000) {
      // }
      this.formOpenHandler(type, editId);
    },
    formOpenHandler(type, editId = null) {
      history.pushState(null, "", location.href);
      this.formToggled = true;
      if (type == "filter") {
        this.showFilter = true;
      } else if (type == "edit") {
        this.editLoading = editId;
        this.postId = editId;
        this.EditModel = true;
      } else if (type == "add") {
        this.$router.push('/builder-create-post')
      }
    },
    formCloseHandler(type) {
      let self = this;
      history.back();
      setTimeout(() => {
        self.formToggled = false;
        if (type == "filter") {
          self.showFilter = false;
          self.clearForm();
        } else if (type == "edit") {
          self.editLoading = null;
          self.EditModel = false;
          // self.fillter.status = "archived";
          // self.filterStatusHandler("archived");
          self.load_post("first");
        } else if (type == "add") {
          self.addFile = false;
        }
      }, 500);
    },
    handleBackBtn() {
      if (this.showFilter) {
        this.showFilter = false;
        this.clearForm();
      } else if (this.EditModel) {
        this.editLoading = null;
        this.EditModel = false;
        // this.load_post("first");
      } else if (this.addFile) {
        this.addFile = false;
      }
      this.formToggled = false;
      this.formType = "";
    },
    // postSaveHandler() {
    // },
    reAdsPost(id) {
      this.$swal
        .fire({
          title: "آگهی فعال شود؟",
          text: "پس از این عملیات، آگهی در لیست آگهی های فعال قرار می‌گیرد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "تایید",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              let self = this;
              console.log("post id", id);
              this.helperPost("change-status", {
                post_id: id,
                status: "approved",
              })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    self.fillter.status = "approved";
                    // self.filterStatusHandler("approved");
                    self.load_post("first");
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    del_post(id) {
      let self = this;
      this.$swal
        .fire({
          title: "پروژه حذف گردد؟",
          text: "پس از این عملیات پروژه برای همیشه حذف میگردد.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#0096c7",
          cancelButtonColor: "#fff",
          confirmButtonText: "حذف",
          cancelButtonText: "انصراف",
        })
        .then((result) => {
          if (result.isConfirmed) {
            if (result.value) {
              self.delLoading = true;
              this.helperPost("del-post", { post_id: id })
                .then((r) => {
                  if (r.data.result == "1") {
                    toast(r.data.msg, {
                      type: "success",
                      dangerouslyHTMLString: true,
                    });
                    this.showDetails = false;
                    setTimeout(() => {
                      self.load_post("first");
                    }, 500);
                  } else {
                    toast(r.data.msg, {
                      type: "error",
                      dangerouslyHTMLString: true,
                    });
                  }
                  self.delLoading = false;
                })
                .catch(function () {
                  self.loading = false;
                });
            }
          }
        });
    },
    // del_post(id) {
    //   this.$swal
    //     .fire({
    //       title: "آگهی حذف گردد؟",
    //       text: "پس از این عملیات آگهی برای همیشه حذف میگردد.",
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#0096c7",
    //       cancelButtonColor: "#fff",
    //       confirmButtonText: "حذف",
    //       cancelButtonText: "انصراف",
    //     })
    //     .then((result) => {
    //       if (result.isConfirmed) {
    //         if (result.value) {
    //           let self = this;
    //           this.helperPost("del-post", { post_id: id })
    //             .then((r) => {
    //               if (r.data.result == "1") {
    //                 toast(r.data.msg, {
    //                   type: "success",
    //                   dangerouslyHTMLString: true,
    //                 });
    //                 self.load_post("first");
    //               } else {
    //                 toast(r.data.msg, {
    //                   type: "error",
    //                   dangerouslyHTMLString: true,
    //                 });
    //               }
    //             })
    //             .catch(function () {
    //               self.loading = false;
    //             });
    //         }
    //       }
    //     });
    // },
  },
};
</script>

<style lang="scss" scoped>
.topNav__searchbar_wrapper {
  width: 60% !important;
}
.loadButtonarea {
  width: 100%;
  margin-top: 36px;
}
.loadButtonarea .loadButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 220px;
  height: 48px;
  text-align: center;
  background: #2dc653;
  font-family: "iranyekanB", sans-serif;
  font-size: 0.9rem;
  color: #fff;
  border-radius: 8px;
  margin: 0 auto;
}
.loader {
  height: 40px;
  width: 40px;
  margin-top: 0 !important;
}

.editLoader {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.showFileBtns {
  display: grid;
  grid-template-columns: 49% 49%;
  justify-content: space-between;
}

.mobileFileTitle {
  display: none;
}

.fileStatusThumb {
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 6px 12px;
  border-radius: 24px;
  font-size: 0.8rem;
  background: #0096c7;
  color: #fff;
  z-index: 2;

  &.approved {
    background: #01d06f;
  }

  &.pending {
    background: #7f8c8d;
  }

  &.inactive {
    background: #f00;
  }
}

@media (max-width: 600px) {
  .desktopFileTitle {
    display: none !important;
  }

  .TopShowToUserCdn {
    position: relative;
    img {
      height: 242px;
    }
  }

  .mobileFileTitle {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: block;
    width: 100%;
    padding: 7px;
    font-family: "iranyekanB", sans-serif;
    font-size: 1rem;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.7);
  }
}


:deep(.el-overlay.profileDetails) {
  .el-dialog {
    padding: 0;
    width: 90%;
    max-width: 1024px;
    height: 90vh;
    border-radius: 8px !important;
    position: relative;

    .el-dialog__body {
      height: 100%;
    }

    .el-dialog__header {
      display: none;
    }

    .changePostBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      cursor: pointer;
      border-radius: 50%;
      color: #000;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
      transition: all 0.1s;

      &:active {
        transform: translateY(-50%) scale(0.95);
      }

      svg {
        width: 28px;
        height: 28px;
      }

      &.PrevBtn {
        right: -8%;
      }

      &.NextBtn {
        left: -8%;
      }
    }

    .detailsContainer {
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 4px;

      .containerList {
        width: 100%;
        height: 100%;

        .listThumb {
          width: 100%;
          height: 100%;
          display: flex;

          .thumbPic {
            width: 60%;
            height: 100%;
            flex-shrink: 0;
            background: #f9fafb;
            border-bottom-right-radius: 8px !important;
            border-top-right-radius: 8px !important;
            overflow: hidden;

            .swiper {
              height: 100% !important;
            }

            .swiper-button-next,
            .swiper-button-prev {
              width: 36px;
              height: 36px;
              background: rgba(0, 0, 0, 0.4);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 20px;
              color: #fff !important;

              &::after {
                font-size: 20px !important;
                font-weight: 700 !important;
                position: absolute !important;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              }
            }

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .thumbContent {
            position: relative;
            width: 40%;
            height: 100%;
            overflow: hidden;
            padding-top: 74px;

            .contentHeader {
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              z-index: 99;
              background: #fff;
              padding: 16px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-top-left-radius: 8px !important;
              border-bottom: 1px solid rgb(229 231 235);

              .headerContent {
                display: flex;
                align-items: center;
                gap: 12px;

                .contentPic {
                  width: 42px;
                  height: 42px;
                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    object-fit: cover;
                  }
                }

                .contentInfo {
                  font-family: "iranyekanB", sans-serif;
                  font-size: 1rem;
                  color: #000;
                }
              }

              .headerOptions {
                display: flex;
                align-items: center;
                gap: 8px;
                .optionFollow {
                  height: 32px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 0.85rem;
                  color: #fff;
                  background: #0096c7;
                  border-radius: 9999px;
                  padding: 0 16px;
                }
                .optionUnFollow {
                  height: 32px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 0.85rem;
                  color: #0096c7;
                  border: 2px solid #0096c7;
                  background: #fff;
                  border-radius: 9999px;
                  padding: 0 16px;
                }

                .optionEditBtn {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  font-size: 0.925rem;
                  color: #fff;
                  width: 32px;
                  height: 32px;
                  border-radius: 6px;
                  background: #0096c7;
                }

                .optionDelete {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  font-size: 0.925rem;
                  color: #fff;
                  width: 32px;
                  height: 32px;
                  border-radius: 6px;
                  background: #f00;
                }
              }
            }

            .contentMain {
              width: 100%;
              height: calc(100% - 56.8px);
              overflow-x: hidden;
              overflow-y: auto;
              padding: 16px;

              .mianHeader {
                padding-bottom: 16px;
                border-bottom: 1px solid rgb(243 244 246);

                .headerStatus {
                  width: fit-content;
                  padding: 4px 8px;
                  border-radius: 24px;
                  background: #f7f7f7;
                  font-size: 0.8rem;
                  color: #0096c7;
                  margin-bottom: 8px;
                }

                .headerTitle {
                  font-family: "iranyekanB", sans-serif;
                  font-size: 1rem;
                  color: #000;
                }

                .headerContent {
                  font-size: 0.9rem;
                  text-align: justify;
                  line-height: 28px;
                  color: #000;
                }
              }

              .mainOptions {
                width: 100%;
                display: flex;
                align-items: flex-start;
                justify-content: space-between;
                padding: 12px 0;

                .optionsList {
                  display: flex;
                  align-items: flex-start;

                  .optionThumb {
                    width: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: start;
                    flex-direction: column;
                    color: #000;
                    gap: 8px;
                    cursor: pointer;

                    &.liked {
                      color: #f00;

                      .thumbNum {
                        color: #000;
                      }
                    }

                    svg {
                      width: 28px;
                      height: 28px;
                      flex-shrink: 0;
                    }

                    .thumbNum {
                      font-size: 0.95rem;
                      line-height: 1.25rem;
                    }
                  }
                }
              }

              .mainList {
                width: 100%;
                padding-top: 12px;

                .listThumb {
                  display: block;
                  box-shadow: none;
                  .listThumbWrapper {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                    margin-bottom: 16px;

                    .thumbPic {
                      width: 42px;
                      height: 42px;
                      flex-shrink: 0 !important;

                      img {
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                      }
                    }

                    .thumbContent {
                      flex-grow: 1 !important;
                      padding: 0 !important;
                      .contentDesc {
                        font-size: 0.875rem;
                        color: rgb(55 65 81);
                        line-height: 24px;
                        height: auto;

                        .userTitle {
                          font-family: "iranyekanB", sans-serif;
                          margin-left: 2px;
                          color: #000;
                        }
                      }

                      .contentDetails {
                        margin-top: 4px;
                        display: flex;
                        align-items: center;
                        gap: 16px;
                        color: rgb(107 114 128);
                        font-size: 0.75rem;

                        .detailsReply {
                          cursor: pointer;
                          transition: all 0.2s;

                          &:hover {
                            color: #0096c7;
                            transform: scale(1.05);
                          }
                        }
                      }
                    }
                  }

                  .thumbReplyList {
                    padding-right: 42px;

                    .listThumb {
                      .listThumbWrapper {
                        .thumbPic {
                          width: 32px;
                          height: 32px;
                        }

                        .thumbContent {
                          .contentDesc {
                            font-size: 0.75rem;
                          }
                          .contentDetails {
                            font-size: 0.675rem;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            .contentFooter {
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              background: #fff;
              padding: 8px 16px;
              border-bottom-left-radius: 8px !important;
              border-top: 1px solid rgb(229 231 235);

              .footerFooter {
                .footerGroup {
                  position: relative;
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  .groupButton {
                    width: 40px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    flex-shrink: 0;
                    cursor: pointer;

                    svg {
                      width: 24px;
                      height: 24px;
                      fill: #0096c7;
                    }
                  }

                  .groupInput {
                    flex-grow: 1;
                    padding: 12px;
                    padding-right: 0;
                    font-size: 0.9rem;
                    background: transparent;
                  }

                  .cancleReply {
                    flex-shrink: 0;
                    padding: 4px 8px;
                    background: #c2e1ea;
                    color: #0096c7;
                    border-radius: 9999px;
                    cursor: pointer;
                    font-size: 0.75rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.dark {
  .listThumb {
    box-shadow: 0 4px 6px -1px rgb(255 255 255 / 0.1),
      0 2px 4px -2px rgb(255 255 255 / 0.1);
    background: #101a23;

    .thumbContent {
      .contentTitleWrapper {
        color: #fff;
      }

      .contentStatus {
        background: #3c3232;
      }

      .contentDesc {
        color: rgb(139, 150, 167);
      }

      .contentDetails {
        .detailsRate {
          .rateThumb {
            color: rgb(139, 150, 167);
          }
        }
      }
    }
  }
}

.listThumb {
  width: 100%;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
    0 2px 4px -2px rgb(0 0 0 / 0.1);
  background: #fff;
  border-radius: 12px;
  .thumbPic {
    width: 100%;
    height: 192px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
  .thumbContent {
    padding: 24px;
    .contentTitleWrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      margin-bottom: 8px;
    }
    .contentStatus {
      width: fit-content;
      padding: 4px 8px;
      border-radius: 24px;
      background: #f7f7f7;
      font-size: 0.8rem;
      color: #0096c7;
      flex-shrink: 0;
    }
    .contentTitle {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      font-size: 1.125rem;
      line-height: 1.75rem;
      font-family: "iranyekanB", sans-serif;
      flex-grow: 1;
      text-overflow: ellipsis;
    }
    .contentDesc {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 60px;
      color: rgb(75 85 99);
      font-size: 0.875rem;
      line-height: 1.25rem;
      margin-bottom: 16px;
    }
    .contentDetails {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .detailsRate {
        display: flex;
        align-items: center;
        gap: 16px;
        .rateThumb {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          color: rgb(107 114 128);
          font-size: 0.875rem;
          line-height: 1.25rem;
        }
      }
      .detailsDate {
        .dateThumb {
          color: rgb(156 163 175);
          font-size: 0.75rem;
          line-height: 1rem;
        }
      }
    }
  }
}


.mobileNocomments {
  padding: 48px 0;
  font-size: 1rem;
  color: #777;
  text-align: center;
}

.map {
  width: 100%;
  height: 100%;
}

@media (max-width: 700px) {
  .listThumb {
    .thumbContent {
      .contentDesc {
        height: auto;
      }
    }
  }
}

.contentOptions {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;

  .optionBtn {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 0.875rem;
    line-height: 1.25rem;
    border-radius: 12px;
    cursor: pointer;

    &.editBtn {
      background: rgb(59, 130, 246);
      color: #fff;
    }

    &.delBtn {
      background: rgb(239, 68, 68);
      color: #fff;
    }
  }
}

.delLoader {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
</style>
